let code = function(i) {
	this.m = {
		show: true,
		component: 'btnCallCode',
		data: i
	};
	this.$store.commit('core/setOpenModal', this.m);
};
export default code;
